module.exports = __webpack_public_path__ + "images/howtouse/howto-functions02_a27f4178eade31f515a8ecd01e742273.png";